import { render } from "./DefinicoesSC.vue?vue&type=template&id=c4d5d350&scoped=true"
import script from "./DefinicoesSC.vue?vue&type=script&lang=js"
export * from "./DefinicoesSC.vue?vue&type=script&lang=js"

import "./DefinicoesSC.vue?vue&type=style&index=0&id=c4d5d350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d5d350"]])

export default __exports__